import { gql } from '@apollo/client';

export const NODE_LAYOUT_FRAGMENT = gql`
  fragment NodeLayout on ReportNodeLayout {
    id
    name
    type
    characterLimit
  }
`;

export const NODE_LAYOUT_SETTINGS_FRAGMENT = gql`
  fragment NodeLayoutSettings on Report {
    nodeLayoutSettings {
      nodes {
        id
        layout {
          ...NodeLayout
        }
        settings {
          __typename
          ... on NodeLayoutAssetSectionSetting {
            id
            centerHeader
            leftHeader
            rightHeader
          }
          ... on NodeLayoutCoverPageSetting {
            id
            showCoverPhoto
            showCompanyLogo
            showCompanyName
            showCreatorName
            showPhotoCount
            showDateCreated
          }
        }
      }
    }
  }

  ${NODE_LAYOUT_FRAGMENT}
`;

export const REPORT_SETTINGS_FRAGMENT = gql`
  fragment ReportSettings on Report {
    reportSettings {
      id
      showPhotoNumber
      showPhotoCreator
      showPhotoCapturedAt
      showPhotoLocation
      showPhotoTags
      showSectionSummary
    }
  }
`;

export const PHOTO_ANNOTATED_URIS_FRAGMENT = gql`
  fragment PhotoAnnotatedUrisFragment on ReportPhoto {
    annotatedUris(variants: [THUMBNAIL, MEDIUM, ORIGINAL]) {
      variant
      uri
    }
  }
`;

export const REPORT_PHOTO_ANNOTATED_URIS_FRAGMENT = gql`
  fragment ReportPhotoAnnotatedUrisFragment on ReportPhoto {
    annotatedUris(variants: [THUMBNAIL, MEDIUM, ORIGINAL]) {
      variant
      uri
    }
  }
`;

export const COMMON_ASSET_FIELDS = gql`
  fragment CommonAssetFieldsFragment on AssetFeedItem {
    id
    databaseId
    assetPreviewThumbnail
    assetPreviewLarge
    createdAt
    capturedAt
    project {
      id
      name
      databaseId
      streetAddress1
    }
    contributor {
      __typename
      ... on ProjectContributorInterface {
        id
        name
        avatar
        companyId
        companyName
      }
    }
  }
`;

export const REPORT_NODE_FRAGMENT = gql`
  fragment ReportNode on ReportNode {
    id
    creatorId
    type
    name
    position
    parent {
      id
      type
      name
    }
    data {
      ... on ReportNodeAssetContainerData {
        id
        text
        projectId
        creatorId
        capturedAt
        tags
        reportPhoto {
          ...ReportPhotoAnnotatedUrisFragment
          id
          databaseId
          assetPreviewThumbnail
          assetPreviewLarge
          createdAt
          capturedAt
          reportProjectInfo {
            id
            name
            databaseId
            streetAddress1
          }
          contributor {
            __typename
            ... on ProjectContributorInterface {
              id
              name
              avatar
              companyId
              companyName
            }
          }
          originalUris(variants: [THUMBNAIL, MEDIUM, ORIGINAL]) {
            variant
            uri
          }
          metadata
          description {
            id
            databaseId
            content
          }
        }
      }
      ... on ReportNodeAssetSectionData {
        id
        summary
      }
      ... on ReportNodeCoverPageData {
        id
        imageId
        imageUrl
        logoUrl
      }
    }
  }
  ${REPORT_PHOTO_ANNOTATED_URIS_FRAGMENT}
`;

export const REPORT_NODES_FRAGMENT = gql`
  fragment ReportNodes on Report {
    reportNodes {
      nodes {
        ...ReportNode
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
`;
